import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getProperties = async () => {
  const { data } = await client.get("/properties");
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await client.post("/contact", payload);
  return data;
};

export default client;
